import XkHintBox from './src/hintBox.vue'

XkHintBox.install = function (Vue) {
  Vue.component(XkHintBox.name, XkHintBox)
}

export default XkHintBox



// WEBPACK FOOTER //
// ./src/components/module/hintBox/index.js